import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { AzureCosmosMongoDbApiSink } from 'app/model/pipeline/copysink/azure-cosmos-mongodb-api.copysink';
import { CopySinkAdapter } from './copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosMongoDbApiSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*',
        writeBatchSize: '*',
        writeBatchTimeout: '*',
        structure: '*'
    }
})
export class AzureCosmosMongoDbApiSinkAdapter extends CopySinkAdapter<
    AzureCosmosMongoDbApiSink,
    Model.DocumentDbMongoDbApiCollectionSink
> {
    protected override async _toResource(
        model: AzureCosmosMongoDbApiSink
    ): Promise<Model.DocumentDbMongoDbApiCollectionSink> {
        const result: Model.DocumentDbMongoDbApiCollectionSink = {
            type: Metamodel.modelFor(AzureCosmosMongoDbApiSink).name
        };
        const writeBatchTimeout = ValueAdapter.toResource(model, AzureCosmosMongoDbApiSink.WRITE_BATCH_TIMEOUT);
        if (writeBatchTimeout != null && writeBatchTimeout !== '') {
            // don't need pass '' to backend
            result.writeBatchTimeout = writeBatchTimeout;
        }
        result.writeBatchSize = ValueAdapter.toResource(model, AzureCosmosMongoDbApiSink.WRITE_BATCH_SIZE);
        result.writeBehavior = ValueAdapter.toResource(model, AzureCosmosMongoDbApiSink.WRITE_BEHAVIOR);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.DocumentDbMongoDbApiCollectionSink,
        owner: Activity
    ): Promise<AzureCosmosMongoDbApiSink> {
        const result = Owned.create<AzureCosmosMongoDbApiSink>(Metamodel.modelFor(AzureCosmosMongoDbApiSink), owner);
        ValueAdapter.toModel(result, AzureCosmosMongoDbApiSink.WRITE_BATCH_TIMEOUT, resource.writeBatchTimeout);
        ValueAdapter.toModel(result, AzureCosmosMongoDbApiSink.WRITE_BATCH_SIZE, resource.writeBatchSize);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.upsert:
                    writeBehavior = writeBehaviorOptionValues.upsert;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, AzureCosmosMongoDbApiSink.WRITE_BEHAVIOR, writeBehavior);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
